import React, { useCallback, useContext, useEffect, useState } from 'react'
import { View, ScrollView, StyleSheet, Text } from 'react-native'
import { Sidebar } from '../components/sections/Sidebar'
import { TopBar } from '../components/sections/TopBar'
import { getStyleSheet } from '../assets/theme/styles'
import TabNative from '../components/common/Tab'
import { ClientService } from '../services/ClientService'
import GroupedRecordMenu from '../components/common/GroupedRecordMenu/GroupedRecordMenu'
import { Client, StatusProject } from '../models'
import { useToast } from 'react-native-toast-notifications'
import { LoadingSpinner } from '../components/common/LoadingSpinner'
import { TagsService } from '../services/TagsService'
import { ThemeContext } from '../assets/theme/ThemeProvider'
import Setting from '../components/common/ClientTab/Setting'
import { useFocusEffect } from '@react-navigation/native'

export interface IClient extends Client {
    _version: number
    arrayTags: { id: string; name: string; code: string; color: string }[]
}

const options = [{ name: 'SETTINGS', value: 'settings' }]

const ClientDetails = ({ ...props }) => {
    const current = 'ClientDetails'
    const styles = getStyleSheet()
    const { userSub } = useContext<any>(ThemeContext)
    const [client, setClient] = useState<IClient | null>(null)
    const [clientName, setClientName] = useState('')
    const { clientId } = props.route.params
    const [valueSelectButton, setValueSelectButton] = useState('')
    const toast = useToast()
    const { getAllTags } = TagsService()
    const [tags, setTags] = useState<any[]>([])

    const onChangeSelectButton = (value: string | number) => {
        props.navigation.setParams({ edit: value })
        setValueSelectButton(value as string)
        if (value === 'settings') getClientDetails()
    }

    const getClientDetails = async () => {
        const client = await ClientService().getClientById(clientId)
        if (client) setClient(client)
    }

    const onUpdateClient = async (id: any, newObject: any = null) => {
        if (id && client) {
            newObject = {
                id: client.id,
                status: StatusProject.ARCHIVED,
                _version: client._version,
            }
        }

        ClientService()
            .updateClientById(newObject)
            .then(() => {
                toast.show('Client was updated successfully', { type: 'success' })
            })
            .catch(() => {})
    }

    const actions = [
        {
            action: () => onUpdateClient(client?.id),
            label: 'Archived',
            icon: 'archive',
        },
    ]

    useFocusEffect(
        useCallback(() => {
            getClientDetails()
            return () => setClient(null)
        }, [clientId])
    )

    useFocusEffect(
        useCallback(() => {
            getAllTags(userSub).then(tags => setTags(tags))
        }, [userSub])
    )

    useFocusEffect(
        useCallback(() => {
            if (props.route.params?.edit) setValueSelectButton(props.route.params.edit)
            else setValueSelectButton('settings')
        }, [props.route.params?.edit])
    )

    return (
        <View style={localStyles.container}>
            <Sidebar children={{ active: current }} />
            <View style={localStyles.subcontainer}>
                <ScrollView
                    contentContainerStyle={!client ? { flexGrow: 1, overflow: 'hidden' } : {}}
                    style={[styles.styleBackground.container]}
                    stickyHeaderIndices={[0]}
                >
                    <TopBar children={{ active: current, initial: 0 }} />
                    {!client ? (
                        <LoadingSpinner loadVisible={true} />
                    ) : (
                        <View style={localStyles.workArea}>
                            <View style={{ flexDirection: 'row', justifyContent: 'space-between', marginBottom: 20 }}>
                                <Text style={{ fontSize: 18, fontWeight: '600', color: styles.text }}>
                                    {clientName}
                                </Text>
                                <GroupedRecordMenu identificator={client.id} items={actions} />
                            </View>
                            <TabNative
                                containerStyle={{ height: 42, alignSelf: 'flex-start' }}
                                buttonStyle={{ height: 42 }}
                                value={valueSelectButton}
                                onChange={onChangeSelectButton}
                                options={options}
                            />
                            <View style={{ backgroundColor: styles.formContainerBackground, padding: 20 }}>
                                {valueSelectButton === 'settings' && (
                                    <Setting
                                        client={client}
                                        tags={tags}
                                        onUpdateRow={onUpdateClient}
                                        setClientName={setClientName}
                                    />
                                )}
                            </View>
                        </View>
                    )}
                </ScrollView>
            </View>
        </View>
    )
}

const localStyles = StyleSheet.create({
    container: {
        flex: 1,
        flexDirection: 'row',
    },
    subcontainer: {
        flex: 1,
        flexDirection: 'column',
        backgroundColor: '#fff',
    },
    workArea: {
        width: 'auto',
        marginLeft: 29,
        marginRight: 29,
        marginTop: 29,
    },
    searchContainer: {
        zIndex: 5010,
        flexDirection: 'row',
        marginBottom: 12,
        height: 41,
    },
    textInputSearch: {
        paddingLeft: 10,
        width: 295,
        height: 40,
        borderColor: 'gray',
        borderRadius: 6,
        fontStyle: 'italic',
    },
    iconSearch: {
        width: 22,
        height: 22,
        position: 'absolute',
        marginTop: 10,
        right: 10,
    },
})

export default ClientDetails
